import { Nav } from "react-bootstrap";
import { Link, NavLink, useMatch } from "react-router-dom";

const ManageNav = () => {
  // The Household Groups paths are below the Households path, which a
  // `NavLink` matches by prefix. On them the Households tab is a plain link, so
  // only the Household Groups tab is the active one.
  const isHouseholdGroups =
    useMatch("/clients/households/household-groups/*") !== null;

  return (
    <nav>
      <Nav variant="tabs" defaultActiveKey="/clients/households">
        <Nav.Item>
          {isHouseholdGroups ? (
            <Link to="/clients/households" className="nav-link">
              Households
            </Link>
          ) : (
            <NavLink to="/clients/households" className="nav-link">
              Households
            </NavLink>
          )}
        </Nav.Item>
        <Nav.Item>
          <NavLink to="/clients/accounts" className="nav-link">
            Accounts
          </NavLink>
        </Nav.Item>
        <Nav.Item>
          <NavLink to="/clients/contacts" className="nav-link">
            Contacts
          </NavLink>
        </Nav.Item>
        <Nav.Item>
          <NavLink
            to="/clients/households/household-groups"
            className="nav-link"
          >
            Household Groups
          </NavLink>
        </Nav.Item>
      </Nav>
    </nav>
  );
};

export default ManageNav;
